import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.25 12.5959L10 10.8459L11.75 12.5959L12.6281 11.7177L10.8781 9.96774L12.6281 8.21774L11.75 7.33961L10 9.08961L8.25 7.33961L7.37188 8.21774L9.12188 9.96774L7.37188 11.7177L8.25 12.5959ZM10 17.9004C8.19764 17.4089 6.70542 16.348 5.52333 14.7177C4.34111 13.0875 3.75 11.2648 3.75 9.24982V4.45503L10 2.11523L16.25 4.45503V9.24982C16.25 11.2648 15.6589 13.0875 14.4767 14.7177C13.2946 16.348 11.8024 17.4089 10 17.9004ZM10 16.5832C11.4444 16.1248 12.6389 15.2082 13.5833 13.8332C14.5278 12.4582 15 10.9304 15 9.24982V5.31232L10 3.44524L5 5.31232V9.24982C5 10.9304 5.47222 12.4582 6.41667 13.8332C7.36111 15.2082 8.55556 16.1248 10 16.5832Z",
		fill: "currentColor"
	})
});
export default SvgDeleteAlert;
